export default "__VITE_ASSET__65a1ddc5__"